/* import __COLOCATED_TEMPLATE__ from './company-network-module.hbs'; */
import Component from '@glimmer/component';
import { COMPANY } from 'sh-www/models/company';

const CLASS_NAME = 'SH-c-company-network-module';

class MyNetworkModuleComponent extends Component {
  get className() {
    return CLASS_NAME;
  }

  get companyStatistics() {
    return this.args.company?.statistics;
  }

  get progressBarLimit() {
    return this.args.company.inviteMax ?? 0;
  }

  get progressBarHex() {
    if (this.atOrAboveTierLimit) return 'D22F55';
    if (!this.progressBarLimit) return '24B26B';
    return 'CDD91C';
  }

  get atOrAboveTierLimit() {
    const { inviteMax } = this.args.company;
    return inviteMax && this.companyStatistics && (this.companyStatistics.totalInNetworkCreators >= Number.parseInt(inviteMax));
  }

  get isOnHighestTier() {
    return this.args.company.tier === COMPANY.TIERS.ENTERPRISE;
  }

  get showDefaultState() {
    const { companyStatistics } = this;
    if (!companyStatistics) return true;
    return companyStatistics.totalInNetworkCreators === 0
      && companyStatistics.inNetworkPendingInvites === 0
      && companyStatistics.inNetworkProjects === 0
      && companyStatistics.inNetworkServices === 0;
  }

  get showProgressBar() {
    return this.args.company.tierVersion === 2
      && [COMPANY.TIERS.PRO, COMPANY.TIERS.BUSINESS, COMPANY.TIERS.ENTERPRISE, COMPANY.TIERS.BLACK].includes(this.args.company.tier);
  }

  /**
   * Compatibility function until tier migration is finalized
   */
  get tierV1ToV2NameTranslations() {
    switch(this.args.company.tier) {
      case 0:
      case 1:
      case 2:
      case 5:
        return 'Create';
      case 3:
        return 'Professional';
      case 4:
        return 'Enterprise';
      default:
        return 'Business';
    }
  }

  get tierV2NameToNextTierName() {
    switch(this.tierV1ToV2NameTranslations) {
      case 'Create':
        return 'Professional';
      case 'Professional':
        return 'Business';
      case 'Business':
        return 'Enterprise';
      default:
        return '';
    }
  }
}

export default MyNetworkModuleComponent;
